import { render, staticRenderFns } from "./EmdContainer.vue?vue&type=template&id=61c59f98&scoped=true&"
import script from "./EmdContainer.vue?vue&type=script&lang=js&"
export * from "./EmdContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmdContainer.vue?vue&type=style&index=0&id=61c59f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c59f98",
  null
  
)

export default component.exports